import App from './components/AppIE.svelte';

const app = new App({
  target: document.body
});

export default app;